// src/components/Admin/organizations/ContactedList.tsx
import React, { useState } from 'react';
import { OrganizationContactedItem } from '../../../api/adminOrganizationsService';
import OrgsTable from './OrgsTable';
import CompanyInfo from './CompanyInfo';

interface Props {
  items: OrganizationContactedItem[];
}

const ContactedList: React.FC<Props> = ({ items }) => {
  const [selected, setSelected] = useState<OrganizationContactedItem | null>(null);

  const tableItems = (items ?? []).map((it) => ({
    org: it.org,
    report: it.report,
    employees: it.employees ?? [],
    total_candidates: it.total_candidates,
  }));

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      {/* Tabla de empresas */}
      <OrgsTable
        items={tableItems as any}
        selectedId={selected?.org.id ?? null}
        onSelect={(row) => {
          const real = (items ?? []).find((x) => x.org.id === row.org.id) ?? null;
          setSelected(real);
        }}
      />

      {/* Detalle de contactos */}
      <div className="grid grid-rows-[auto_1fr] gap-4">
        <CompanyInfo item={selected} />

        <div className="bg-white border rounded-lg p-4 overflow-auto">
          {selected ? (
            <>
              <h4 className="font-semibold mb-3">
                Contactos ({selected.contacts?.length ?? 0})
              </h4>
              <table className="w-full text-xs border rounded">
                <thead>
                  <tr className="text-left text-gray-600">
                    <th className="py-2 pl-3 pr-2">Email</th>
                    <th className="py-2 pr-2">Primera toma</th>
                    <th className="py-2 pr-3">Reminder</th>
                  </tr>
                </thead>
                <tbody>
                  {(selected.contacts ?? []).map((c) => (
                    <tr key={c.email} className="border-t bg-gray-50">
                      <td className="py-2 pl-3 pr-2">
                        <div className="truncate">{c.email}</div>
                        <div className="text-[11px] text-gray-500 truncate">{c.notes}</div>
                      </td>
                      <td className="py-2 pr-2">
                        {c.first_contact_at
                          ? new Date(c.first_contact_at).toLocaleString()
                          : '—'}
                      </td>
                      <td className="py-2 pr-3">
                        {c.reminder_email_sent ? '🔄 enviado' : '—'}
                      </td>
                    </tr>
                  ))}
                  {(selected.contacts ?? []).length === 0 && (
                    <tr>
                      <td className="py-2 px-3 text-gray-400" colSpan={3}>
                        —
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </>
          ) : (
            <div className="text-sm text-gray-500">
              Selecciona una empresa para ver sus contactos.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactedList;
